import Backbone from 'backbone'
import Syphon from 'backbone.syphon'

class KCVS.Views.FilePagesView extends Backbone.View
  events:
    "click .page-preview"                             : "processPageClick"
    "click #new_report_document input[type='submit']" : "processNewDocumentFormSubmit"
    "click .page_mover input[type='submit']"          : "processPageMoverFormSubmit"
    "mouseenter .fa-search-plus"                      : "showEnlargedPreview"
    "mouseleave .fa-search-plus"                      : "hideEnlargedPreview"
    "click [data-action='remove']"                    : "handlePageRemove"
    "click input[name='toggle_ignored']"              : "toggleIgnoredPages"

  initialize: (options) ->
    @newDocumentPageIdsInput = @$el.find('input#report_document_file_page_ids')
    @moverPageIdsInput = @$el.find('input#page_mover_page_ids')
    @alteringDocument = options.altering_document
    @alertBox = $('.alert')
    @pageCountContainer = $('.page-count')
    @ignoredPageCountContainer = $('.ignored-page-count')
    @ajdustPageIdsInputs()

  processPageClick: (e) ->
    $(e.currentTarget).toggleClass('selected')
    _.each $(e.currentTarget).find('.thumb-img >'), (el) -> $(el).toggleClass('hidden')
    @ajdustPageIdsInputs()
    @adjustSubmitButtonText()

  selectedPages: ->
    clickedPages = @$('.page-preview.selected')
    if clickedPages.length == 0
      @$('.page-preview:not(.ignored)')
    else
      @$('.page-preview.selected')

  pageCount: ->
    parseInt(@pageCountContainer.text())

  ignoredPageCount: ->
    parseInt(@ignoredPageCountContainer.text())

  allPagesSelected: ->
    @selectedPages().length == @$(".page-preview").length

  ajdustPageIdsInputs: ->
    ids = _.map @selectedPages(), (page)-> $(page).data('page-id')
    @newDocumentPageIdsInput.val(ids.join(','))
    @moverPageIdsInput.val(ids.join(','))

  adjustSubmitButtonText: ->
    page_count = @selectedPages().length

    $new_document_button = $("#new_report_document input[type='submit']")
    $mover_button = $(".page_mover input[type='submit']")
    buttons = [$new_document_button, $mover_button]

    _.each buttons, (b) -> b.removeClass('hidden')
    if page_count == 0
      _.each buttons, (b) -> b.addClass('hidden')
    else if page_count == 1
      count = "#{page_count} lapu"
    else
      count = "#{page_count} lapām"
      count_mover = "#{page_count} lapas"
    $new_document_button.val("Veidot ar #{count}")
    $mover_button.val("Pievienot #{count_mover || count}")

  processNewDocumentFormSubmit: (e) ->
    e.preventDefault()
    if @alteringDocument
      if @allPagesSelected()
        alert(I18n.t('notices.report_documents.cant_remove_all_pages'))
        return
      return unless confirm(I18n.t('notices.report_documents.selected_pages_will_be_removed'))
    form = e.target.form
    data = Backbone.Syphon.serialize form
    #Something weird is going on with syphon serialization of tags
    data.report_document.tag_list = data.report_document.tag_list[1]
    @alertBox.removeClass('hidden')
    $.ajax
      dataType: 'JSON'
      method: 'POST'
      url: $(form).prop('action')
      data: data
      success: @submitSuccessAction
      error: @submitErrorAction(I18n.t('notices.report_documents.failed_to_create'))

  processPageMoverFormSubmit: (e) ->
    e.preventDefault()
    if @alteringDocument
      if @allPagesSelected()
        alert(I18n.t("notices.report_documents.cant_remove_all_pages"))
        return
      return unless confirm(I18n.t("notices.report_documents.selected_pages_will_be_removed"))
    form = e.target.form
    data = Backbone.Syphon.serialize form

    @alertBox.removeClass('hidden')
    $.ajax
      dataType: 'JSON'
      method: 'POST'
      url: $(form).prop('action')
      data: data
      success: @submitSuccessAction
      error: @submitErrorAction(I18n.t('notices.report_documents.failed_to_move'))

  submitSuccessAction: (response) =>
    @decreasePageCount()
    @alertSuccess(response.message)
    @selectedPages().remove()

  submitErrorAction: (message) =>
    =>
      @alertDanger(message)

  decreasePageCount: (count = null) ->
    count ||= @selectedPages().length
    new_count = @pageCount() - count
    @pageCountContainer.text(new_count)

  increaseIgnoredPageCount: (count = 1) ->
    @ignoredPageCountContainer.text @ignoredPageCount() + count

  showEnlargedPreview: (e) ->
    imageUrl = $(e.currentTarget).data('image-url')
    container = @$('.enlarged-preview-screen')
    container.removeClass('hidden')
    container.css('background-image', "url('#{imageUrl}')")

  hideEnlargedPreview: (e) ->
    container = @$('.enlarged-preview-screen')
    container.addClass('hidden')

  toggleIgnoredPages: (e) =>
    @$('.page-preview.ignored').toggleClass('hidden')

  alertSuccess: (message) ->
    @alertBox.removeClass('alert-danger')
      .removeClass('hidden')
      .addClass('alert-success')
    @alertBox.html(message)

  alertDanger: (message) ->
    @alertBox.addClass('alert-danger')
      .removeClass('hidden')
      .removeClass('alert-success')
    @alertBox.html(message)

  handlePageRemove: (e) =>
    $this = $(e.currentTarget)
    url   = $this.data('url')
    page  = $this.parents('.page-preview')
    # warn if page is being deleted not just ignored
    if @alteringDocument
      return unless confirm I18n.t('notices.file_pages.deleting_page_warning')
    $.post url, (data) =>
      @alertSuccess(data.message)
      @increaseIgnoredPageCount() unless @alteringDocument
      @decreasePageCount(1)
      if @alteringDocument then page.remove() else page.addClass('ignored hidden')
